<template>
  <div class="outer" :style="styleObject">
    <modal :show.sync='show'>
      <div slot="title">{{title}}</div>
      <div slot="content">{{message}}</div>
      <div slot="buttons"
          class="xm-modal-buttons">
        <span class="xm-modal-button xm-modal-button-cancel" v-if="showCancle"
              v-on:click="_onCancel()">{{cancelText}}</span>
        <span class="xm-modal-button"
              v-on:click="_onOk()">{{okText}}</span>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from './Modal';

export default {
  name: 'xm-confirm',
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: '提示'
    },
    message: {
      type: String,
      required: false,
      default: ''
    },
    okText: {
      type: String,
      required: false,
      default: '确定'
    },
    cancelText: {
      type: String,
      required: false,
      default: '取消'
    },
    onOk: {
      type: Function,
      required: false
    },
    onCancel: {
      type: Function,
      required: false
    },
    showCancle: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Modal
  },
  computed: {
    styleObject() {
      return {
        display: this.show ? "block" : "none"
      };
    }
  },
  methods: {
    _onOk() {
      this.onOk && this.onOk();
    },
    _onCancel() {
      this.onCancel && this.onCancel();
    }
  }
};
</script>

<style lang="less" scoped>
  .outer {
    z-index: 999999;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    animation: deepen 0.2s ease-out;
  }
</style>




// WEBPACK FOOTER //
// src/components/Confirm.vue